module.exports = __webpack_public_path__ + "static/media/BZ.6bfe1ba3.svg";